import { render, staticRenderFns } from "./MailGroups.list.vue?vue&type=template&id=ec026d30&"
import script from "./MailGroups.list.vue?vue&type=script&lang=js&"
export * from "./MailGroups.list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports